import React from 'react';

export const ArrowDownIcon = (props: any) => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.09424 0V12.957H4.24658V0H7.09424Z" />
      <path d="M5.6748 10.8037L9.33008 7.14941L11.3438 9.16309L5.67773 14.8301L0 9.16406L2.01172 7.14844L5.6748 10.8037Z" />
    </svg>
  );
};
